const returnValueForSelect = (value: any, options: {value: string, label: string}[]) => {
	
	if(!value)
		return "";
	if(typeof value === "object")
		return value;
	if(typeof value === "string"){
		const obj = options?.find((option) => option.value === value);
		if(!obj)
			return "";
		return obj;
	}
	return "";
};

export default returnValueForSelect;
